import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MultiSelectAvatar from "./MultiSelectAvatar";
import { compareTwo } from "../utils";
import { crewSelection, getCrewInfo } from "../../../actions/crew-kanban";

const CrewSelection = props => {
    const { refresh, columns, crewList, newCrewList,
        crews, egListById, isRequestingEg, actions } = props;
    const selected = columns.filter(e => e.crewId !== null).map(e => e.crewId);
    const changedCrews = Object.keys(crews).filter(crewId =>
        crewId && crews[crewId] && crews[crewId].hasOwnProperty("isChanged") ? crews[crewId].isChanged : false);

    const onSelect = (item, checked) => {
        const selectedOpt = [...selected];
        if (checked) selectedOpt.push(item.id);
        else selectedOpt.splice(selectedOpt.indexOf(item.id), 1);
        actions.crewSelection(selectedOpt);

        const { added } = compareTwo(selected, selectedOpt);
        if (added.length > 0 && !props.crews.hasOwnProperty(item.id)) actions.getCrewInfo(added);
    };

    useEffect(() => {
        if (Object.keys(egListById).length > 0) {
            const filteredCrewList = crewList.filter(item => !item.is_end_crew).length !== 0
                ? crewList.filter(item => !item.is_end_crew) : crewList;
            let currentSelected = crewList
                .filter(e => selected.indexOf(e.crew_uuid) >= 0)
                .map(e => e.crew_uuid);

            if (currentSelected.length < 5) {
                const restCrews = filteredCrewList.filter(e => currentSelected.indexOf(e.crew_uuid) < 0);
                const maxCount = (5 - currentSelected.length);
                const topSelected = (restCrews.length > 0) ?
                    restCrews
                        .slice(0, restCrews.length >= maxCount ? maxCount : restCrews.length)
                        .map(e => e.crew_uuid) : [];
                currentSelected = [...currentSelected, ...topSelected];
            }

            actions.crewSelection(currentSelected);
            actions.getCrewInfo(currentSelected);
        }
    }, [refresh, egListById, crewList]);

    const oldCrewList = crewList.map(e => {
        const id = e.crew_uuid;
        const name = crews.hasOwnProperty(id) ? crews[id].info.crew_name : e.crew_name;
        return ({ crew_uuid: id, crew_name: name });
    });

    const list = [...oldCrewList, ...newCrewList];
    return <div className={`kanban-filter ${isRequestingEg ? "event-disabled" : ""}`}>
        <MultiSelectAvatar
            className="multi-select-avatar"
            options={list.map(e => ({ id: e.crew_uuid, label: e.crew_name }))}
            selected={selected}
            disabled={changedCrews}
            onSelect={onSelect}
            maxDisplay={6}
            maxSelection={5}
        />
    </div >;
};

const mapStateToProps = state => ({
    refresh: state.crewKanban.refresh,
    crewList: state.crewKanban.crewList,
    crews: state.crewKanban.crews,
    newCrewList: state.crewKanban.newCrewList,
    columns: state.crewKanban.columns,
    isRequestingEg: state.crewKanban.isRequestingEg,
    egListById: state.crewKanban.egListById
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ crewSelection, getCrewInfo }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CrewSelection);